import { styled } from 'styled-components';

import { ScSlider } from '@/components/NativeSlider/components/Slider/styled';

export const ScTournamentsSlider = styled.div`
  ${ScSlider} {
    padding-top: 16px;
    margin-top: -16px;
  }
`;
